/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	var links = document.querySelectorAll('a.button');
	console.log(links);
	for (var i = 0, len = links.length; i < len; i++) {
	links[i].addEventListener('click', function(e) {
		var targetEl = e.target;
		var inkEl = targetEl.querySelector('.ink');

		if (inkEl) {
		inkEl.classList.remove('animate');
		}
		else {
		inkEl = document.createElement('span');
		inkEl.classList.add('ink');
		inkEl.style.width = inkEl.style.height = Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px';
		targetEl.appendChild(inkEl);
		}

		inkEl.style.left = (e.offsetX - inkEl.offsetWidth / 2) + 'px';
		inkEl.style.top = (e.offsetY - inkEl.offsetHeight / 2) + 'px';
		inkEl.classList.add('animate');
	}, false);
	}

// this whole thing needs to go into a function

var element =  document.querySelector( `div.easyrecipe` );
if (typeof(element) != 'undefined' && element != null)
{
  // Exists.
	const recipeTitle = document.querySelector( `.ERSIngredientsHeader` );
	recipeTitle.innerHTML = `What You Need`;

	const recipeInstructions = document.querySelector( `.ERSInstructionsHeader`);
	recipeInstructions.innerHTML = `Cooking Instructions`;

	const replaceContainerClass = document.querySelector( `div.easyrecipe` );
	replaceContainerClass.classList.add(`langone-override`);

	const removeClasses = document.querySelector( `a.ERSPrintBtn` );
	removeClasses.classList.remove(`ui-button`, `ui-widget`, `ui-state-default`, `ui-corner-all`, `ui-button-text-icon-primary`);

	const removeIconClasses = document.querySelector( `.ERSPrintIcon` );
	removeIconClasses.remove(`ui-button-icon-primary`, `ui-icon`, `ui-button-text`, `ERSPrintIcon`);

	const addPrintButtonClasses = document.querySelector( `a.ERSPrintBtn > span` );
	addPrintButtonClasses.classList.add(`fix-print-classes`);
	
	const replacePrintButtonText = document.querySelector( `span.fix-print-classes` );
	replacePrintButtonText.innerHTML = `Print Recipe`;

	const removeSaveClasses = document.querySelector( `a.ERSSaveBtn` );
	removeSaveClasses.classList.remove(`ui-button`, `ui-widget`, `ui-state-default`, `ui-corner-all`, `ui-button-text-icon-primary`, `bigoven`);

	const removeSaveIconClasses = document.querySelector( `.ERSSaveIcon` );
	removeSaveIconClasses.remove(`ui-button-icon-primary`, `ui-icon`, `ui-button-text`, `ERSSaveIcon`);

	const addSaveButtonClasses = document.querySelector( `a.ERSSaveBtn > span` );
	addSaveButtonClasses.classList.add(`fix-save-classes`);

	const replaceSaveButtonText = document.querySelector( `span.fix-save-classes` );
	replaceSaveButtonText.innerHTML = `Save Recipe`;

	jQuery('div.ERSAuthor').remove(); //using remove method in jQuery
	jQuery('div.ERSClear').remove(); //using remove method in jQuery
	function to_position(divid){
		jQuery('html, body').animate({scrollTop:jQuery(divid).position().top - 50 }, 'slow');
	}
	jQuery('#jumpButton').click(function(){to_position('.langone-override')}); 

}

	// ADA things
	jQuery('ul').removeAttr('aria-multiselectable');
	jQuery('nav > ul').removeAttr('aria-multiselectable');
	jQuery('[role=treeitem]').attr("aria-selected", "false");
	jQuery('#left-nav-links').removeAttr('aria-multiselectable');
	jQuery('#right-nav-links').removeAttr('aria-multiselectable');
	jQuery('.is-dropdown-submenu-parent').removeAttr('aria-expanded');

	jQuery('iframe').removeAttr('frameborder width height scrolling').attr('title', 'website iframe content');
	jQuery('.g-recaptcha-response').attr({'aria-hidden': 'true', 'aria-label': 'do not use', 'aria-readonly': 'true'});
	jQuery('#chatra__iframe').removeAttr('allow allowtransparancy sandbox');

	jQuery('#input_2_1').attr('title', 'email address');
	jQuery('.searchandfilter > div > ul > li > input').attr('title', 'search box');
	jQuery('.searchandfilter > div > ul > li > select').attr('title', 'category dropdown');

	jQuery('u').replaceWith(function(){
		return jQuery('<span style="text-decoration:underline" />').append(jQuery(this).contents());
	});
	jQuery('b').replaceWith(function(){
		return jQuery('<strong />').append(jQuery(this).contents());
	});

	jQuery('.imp-main-image').attr('alt', 'retailer map');

// End jQuery
}); 

// ADA things
jQuery(window).on("load", function() {
	jQuery('iframe').removeAttr('frameborder width height scrolling').attr('title', 'website iframe content');
	jQuery('.g-recaptcha-response').attr({'aria-hidden': 'true', 'aria-label': 'do not use', 'aria-readonly': 'true'});
	jQuery('#chatra__iframe').removeAttr('allow allowtransparancy sandbox');

	jQuery('u').replaceWith(function(){
		return jQuery('<span style="text-decoration:underline" />').append(jQuery(this).contents());
	});
});

//add href to jump to recipe button
jQuery('#jumpButton').attr('href', '#wpzoom-recipe-card');

//functions for slide out menu
function openNav() {
	document.getElementById("mySidenav").style.width = "40vw";
	document.getElementById("mySidenav").classList.add("active");
	// document.getElementById("mainOffCanvas").style.marginright = "40vw";
  }
  
  function closeNav() {
	document.getElementById("mySidenav").style.width = "0";
	document.getElementById("mySidenav").classList.remove("active");
	// document.getElementById("mainOffCanvas").style.marginRight= "0";
  }

    
  var element = document.querySelector(`div#location`);
  if (typeof element != 'undefined' && element != null) {
	window.onscroll = function() {
	  stickFunction();
	};
  
	// Get the sticky element
	var sticky = document.getElementById('stick-this');
  
	// Get the offset position of the element
	var fixstop = sticky.offsetTop;
	console.log(fixstop);
  
	// Add the sticky class to the element when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function stickFunction() {
	  if (window.scrollY > 3200) {
		sticky.classList.add('fix-stop');
	  } else {
		sticky.classList.remove('fix-stop');
	  }
	}
  }